import { useQuery } from 'react-query';
import { wgApi } from '../../../../app/src/features/api/wgApi';

interface AnvaFlowsInsurancesResponse {
  items: AnvaCollectionMethod[];
  count: number;
}

export interface AnvaCollectionMethod {
  name: string;
  code: number;
  type: 'POLICY' | 'PACKAGE';
}

export const getAnvaCollectionMethods = async (sessionId: string) => {
  const { data, isError } = await wgApi.get<AnvaFlowsInsurancesResponse>(
    `/v1/api/anvaflows/${sessionId}/collection-methods`,
  );
  if (isError) throw new Error();
  return data;
};

const getUseAnvaCollectionMethods = (sessionId: string) => [
  'anva',
  'collection-methods',
  sessionId,
];

/**
 * IncassoWijzes are the collection methods used in Anva flows.
 */
export const useAnvaCollectionMethods = (sessionId: string) => {
  return useQuery(
    getUseAnvaCollectionMethods(sessionId),
    () => getAnvaCollectionMethods(sessionId),
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      staleTime: Infinity, // Prevent refetching unless explicitly needed
    },
  );
};
